import http from '../http-common';

const API_URL_PATH = 'positions/';
const API_URL_PATH_WITHOUT_BAR = 'positions';

class PositionsDataService {
  findAll(page, limit) {
    return http.get(API_URL_PATH_WITHOUT_BAR + '?page=' + page + '&limit=' + limit);
  }

  findOne(id) {
    return http.get(API_URL_PATH + id);
  }

  create(position, onUploadProgress) {
    const formData = new FormData();

    if (position.introVideo) {
      formData.append('video', position.introVideo);
    }

    Object.keys(position).forEach((key) => {
      if (key !== 'introVideo') {
        const value = position[key];
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      }
    });

    return http.post(API_URL_PATH, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
  }

  update(position, onUploadProgress) {
    const formData = new FormData();

    if (position.introVideo) {
      formData.append('video', position.introVideo);
    }

    Object.keys(position).forEach((key) => {
      if (key !== 'introVideo') {
        const value = position[key];
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      }
    });

    return http.put(API_URL_PATH + position.id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
  }

  delete(id) {
    return http.delete(API_URL_PATH + id);
  }
}

export default new PositionsDataService();
